import moment from "moment";
import { FAILURE, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function obtenerListaSubEstadosIncidente(obj, combo = false, tag) {
    try {
        let data = [];
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/sub-estados-incidente/obtener-lista-sub-estados-incidente",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
            if (combo === false) {
                for (let i = 0; i < data.length; i++) {
                    data[i].fechaProceso = moment(data[i].fechaProceso).format("YYYY/MM/DD HH:mm");
                    data[i].habilitadoLabel = data[i].habilitado === 1 ? tag("column_habilitado") : tag("column_deshabilitado");
                }
            }
            if (combo === true) {
                data = data.map((item) => {
                    return {
                        value: item.id,
                        label: item.codigo + "-" + item.descripcion,
                    };
                });
            }
        }
        return data;
    } catch (err) {
        console.log("obtenerListaSubEstadosIncidente err");
        console.log(err);
        return [];
    }
}

export async function crearSubEstadosIncidente(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/sub-estados-incidente/crear-sub-estados-incidente",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("crearSubEstadosIncidente err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function actualizarSubEstadosIncidente(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/sub-estados-incidente/actualizar-sub-estados-incidente",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("actualizarSubEstadosIncidente err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function deshabilitarSubEstadosIncidente(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/sub-estados-incidente/deshabilitar-sub-estados-incidente",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("deshabilitarSubEstadosIncidente err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function habilitarSubEstadosIncidente(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/sub-estados-incidente/habilitar-sub-estados-incidente",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("habilitarSubEstadosIncidente err");
        console.log(err);
        return { error: true, message: err };
    }
}